module.exports = __webpack_public_path__ + "static/img/antares-cgas.a02cb90.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/thumbs/antares-cgas.png
// module id = HQoY
// module chunks = 0